class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateCustomSelects();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateCustomSelects() {
    if (
      this.querySelectorAll("[data-custom-select]").length == 0 &&
      window.EasySelect
    )
      return;

    this.querySelectorAll("[data-custom-select]").forEach((select) => {
      const instance = EasySelect.get(select.id);
      if (instance) instance.refresh();
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(
      `slider-${this.dataset.section}`
    );
    const thumbnailsGridySlider = document.getElementById(
      `thumbnail-slider-${this.dataset.section}`
    );

    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }

    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(
        `thumbnail-item-${this.currentVariant.featured_media.id}`
      );
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector(
      "[data-product-inventory]"
    );

    if (
      !this.productInventoryNode ||
      !window.inventories ||
      !window.inventories[this.dataset.productId]
    )
      return;

    this.inventoryThreshold = parseInt(
      this.productInventoryNode.dataset.threshold
    );
    this.showQuantityInStock =
      this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject =
      window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === "shopify") {
      if (
        variantInventoryObject.quantity <= 0 &&
        variantInventoryObject.incoming === "true" &&
        variantInventoryObject.quantity < this.inventoryThreshold
      ) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(
          true,
          variantInventoryObject.next_incoming_date
        );
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add("hide");
      return;
    }

    this.productInventoryNode.classList.remove(
      "inventory-status--in-stock",
      "inventory-status--low",
      "inventory-status--sold-out",
      "inventory-status--sold-out-continue-selling"
    );

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) <= parseInt(this.inventoryThreshold) &&
      parseInt(quantity) > 0
    ) {
      this.productInventoryNode.classList.add("inventory-status--low");
      if (!this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) > parseInt(this.inventoryThreshold)
    ) {
      this.productInventoryNode.classList.add("inventory-status--in-stock");
      if (!this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) < 1
    ) {
      this.productInventoryNode.classList.add(
        "inventory-status--sold-out-continue-selling"
      );
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add("inventory-status--sold-out");
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove("hide");
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector(
      "[data-incoming-inventory]"
    );
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add("hide");

      return;
    }

    let string = !date
      ? window.variantStrings.inventory.waiting_for_stock
      : window.variantStrings.inventory.will_be_in_stock_after.replace(
          "[date]",
          date
        );

    incomingInventoryNode.classList.remove("hide");
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const buyBarInfoSource = html.getElementById(
          `buy-bar-info-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo)
          destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll(
      ".btn--add-multiplier"
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      if (this.dataset.isPreorder == "true") {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.removeAttribute("disabled");
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector("legend [data-variant-legend]");
      const selectedOption = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute("value");
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ModelPicker extends HTMLElement {
  constructor() {
    super();
    this.productTypes = {
      phoneCase: [window.productTypes.phoneCase, "phone-case"],
      screenProtectors: [
        window.productTypes.screenProtector,
        "screen-protector",
      ],
      lensProtectors: [window.productTypes.lensProtector, "lens-protector"],
      airpodsCase: [window.productTypes.airpodsCase, "airpods-case"],
    };
    this.productType = this.getAttribute("data-current-product-type");
    this.currentColor = this.getAttribute("data-current-color");
    this.caseType = this.getAttribute("data-current-case-type");
    this.screenProtectorType = this.getAttribute(
      "data-current-screen-protector-type"
    );
    this.hasMagsafe = this.getAttribute("data-current-has-magsafe") === "true";
    this.json = JSON.parse(
      this.querySelector("[data-model-picker-json]").textContent
    );

    this.addEventListener("change", this.onModelChange);

    document.addEventListener(
      "woolman:custom-select-init.model-picker",
      this.checkEmptyModel.bind(this)
    );
  }

  checkEmptyModel() {
    Object.entries(this.json.data).forEach(([key, model]) => {
      if (model.products.length === 0) {
        const modelOption = this.querySelector(`[data-es-option="${key}"]`);

        if (modelOption) {
          modelOption.parentElement.remove();
        }
      }
    });
  }

  onModelChange(event) {
    const selectedModel = event.target.value;
    const selectedModelProducts = this.json.data[selectedModel]?.products || [];
    let handle = "";
    const rootUrl = window.routes.root == "/" ? "/" : window.routes.root + "/"; // if user has selected locale convert root url from /en-gb to /en-gb/

    if (this.productTypes.phoneCase.includes(this.productType)) {
      // Find matching product based on color, case type, and hasMagsafe
      let matchingProduct = selectedModelProducts.find(
        (product) =>
          product.color === this.currentColor &&
          product.case_type === this.caseType &&
          this.hasMagsafe == product.has_magsafe
      );

      // If no matching product found, find product based on color and case type only
      if (!matchingProduct) {
        matchingProduct = selectedModelProducts.find(
          (product) =>
            product.color === this.currentColor &&
            product.case_type === this.caseType
        );
      }

      // If matching product found, assign its handle
      if (matchingProduct) {
        handle = matchingProduct.handle;
      } else {
        // If no matching product found, find the handle of the first product with the same case type
        const firstSameCaseProduct = selectedModelProducts.find(
          (product) => product.case_type === this.caseType
        );

        // If product with same case type found, assign its handle
        if (firstSameCaseProduct) {
          handle = firstSameCaseProduct.handle;
        } else {
          // If no product with the same case type found, use the handle of the first product
          if (selectedModelProducts.length > 0) {
            handle = selectedModelProducts[0].handle;
          } else {
            console.error("No products found for the selected model");
            return; // Exit function if no products found
          }
        }
      }
    } else if (this.productTypes.screenProtectors.includes(this.productType)) {
      let matchingProduct = selectedModelProducts.find(
        (product) => product.screen_protector_type === this.screenProtectorType
      );

      if (matchingProduct) {
        handle = matchingProduct.handle;
      } else {
        handle = selectedModelProducts[0].handle;
      }
    } else if (this.productTypes.lensProtectors.includes(this.productType)) {
      let matchingProduct = selectedModelProducts.find(
        (product) => product.lens_protector_type === this.lensProtectorType
      );

      if (matchingProduct) {
        handle = matchingProduct.handle;
      } else {
        handle = selectedModelProducts[0].handle;
      }
    } else if (this.productTypes.airpodsCase.includes(this.productType)) {
      let matchingProduct = selectedModelProducts.find(
        (product) =>
          product.color === this.currentColor &&
          product.case_type === this.caseType
      );

      if (matchingProduct) {
        handle = matchingProduct.handle;
      } else {
        const firstSameCaseProduct = selectedModelProducts.find(
          (product) => product.case_type === this.caseType
        );

        // If product with same case type found, assign its handle
        if (firstSameCaseProduct) {
          handle = firstSameCaseProduct.handle;
        } else {
          // If no product with the same case type found, use the handle of the first product
          if (selectedModelProducts.length > 0) {
            handle = selectedModelProducts[0].handle;
          } else {
            console.error("No products found for the selected model");
            return; // Exit function if no products found
          }
        }
      }
    }

    window.location.href = `${rootUrl}products/${handle}`;
  }
}

customElements.define("model-picker", ModelPicker);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.image = this.querySelector(".card-media img");

    if (this.select) {
      this.select.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute("data-variant-img-src");
        if (newImgSrc) {
          this.updateImage(newImgSrc);
        }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define("upsell-card", UpsellCard);
